import F7 from "../../../../utils/F7";
import { ChangeEvent, FC, useRef } from "react";
import { Field } from "../FieldHandler";

const ComboboxField: FC<{
  field: Field & { type: "combobox" };
  onChange: (key: string, value: string | undefined) => void;
}> = ({ field, onChange }) => {
  const ref = useRef<HTMLInputElement | null>(null);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const id = field.key;
    const value = e.target.value;
    onChange(id, value);
  };

  const handlePickerChange = (_e: unknown, values: string[]) => {
    const id = field.key;
    const value = values[0];
    onChange(id, value);
  };

  const values = Array.isArray(field.options) ? [...field.options] : field.options.split("\n");
  if (field.value && !values.includes(field.value)) {
    values.unshift(field.value);
  }
  values.unshift("");

  if (values.length) {
    F7.picker({
      input: ref.current!,
      inputReadOnly: false,
      convertToPopover: false,
      value: [field.value!],
      closeByOutsideClick: true,
      onChange: handlePickerChange,
      toolbarTemplate: `<div class="toolbar">
                                <div class="toolbar-inner">
                                  <div class="left">Select or type</div>
                                  <div class="right">
                                    <a href="#" class="link close-picker">{{closeText}}</a>
                                  </div>
                                </div>
                              </div>`,
      cols: [
        {
          values: values,
        },
      ],
    });
  }

  return (
    <span>
      <input
        ref={ref}
        type="text"
        value={field.value || undefined}
        placeholder={field.required ? "required" : ""}
        onChange={handleChange}
      />
    </span>
  );
};

export default ComboboxField;
